import * as Dfns from 'date-fns/fp';

export const BY_COUNT_LABEL = 'Count';
export const BY_SPEND_LABEL = 'Spend';

export const NETWORK_AVAIL_LABEL = 'Network/Avail';
export const EXPANDED_LABEL = 'Expanded';

export const DATE_FORMAT = 'yyyy-MM-dd';
export const CURRENT_WEEK = Dfns.format(DATE_FORMAT)(Dfns.startOfISOWeek(new Date()));

export const NOTE_PRESET_OPTIONS = [
  'Bonus',
  'Not ordered (day/daypart)',
  'Not ordered (network/length)',
  'Overpaid',
  'Paid programming',
  'Too many paid spots',
  'Bad spot separation',
  'Underpaid',
  'WideOrbit',
  'Wrong ISCI',
  'Accept',
  'Credit'
];

export const PLAN_DETAIL_KEYS_TO_SUM = [
  'booked_count',
  'booked_spend',
  'cleared_count',
  'cleared_spend',
  'booked_m',
  'booked_tu',
  'booked_w',
  'booked_th',
  'booked_f',
  'booked_sa',
  'booked_su',
  'cleared_m',
  'cleared_tu',
  'cleared_w',
  'cleared_th',
  'cleared_f',
  'cleared_sa',
  'cleared_su'
];

export const PLAN_DETAIL_CSV_HEADERS = [
  { label: 'Week', name: 'week' },
  { label: 'Network', name: 'network' },
  { label: 'Avail', name: 'avail' },
  { label: 'Length', name: 'length' },
  { label: 'Days', name: 'dow' },
  { label: 'Daypart', name: 'daypart' },
  { label: 'Rotation', name: 'rotation' },
  { label: 'Type', name: 'type' },
  { label: 'Unit Cost', name: 'cost' },
  { label: 'Booked M', name: 'booked_m' },
  { label: 'Booked Tu', name: 'booked_tu' },
  { label: 'Booked W', name: 'booked_w' },
  { label: 'Booked Th', name: 'booked_th' },
  { label: 'Booked F', name: 'booked_f' },
  { label: 'Booked Sa', name: 'booked_sa' },
  { label: 'Booked Su', name: 'booked_su' },
  { label: 'Booked Count', name: 'booked_count' },
  { label: 'Booked Spend', name: 'booked_spend' },
  { label: 'Cleared M', name: 'cleared_m' },
  { label: 'Cleared Tu', name: 'cleared_tu' },
  { label: 'Cleared W', name: 'cleared_w' },
  { label: 'Cleared Th', name: 'cleared_th' },
  { label: 'Cleared F', name: 'cleared_f' },
  { label: 'Cleared Sa', name: 'cleared_sa' },
  { label: 'Cleared Su', name: 'cleared_su' },
  { label: 'Cleared Count', name: 'cleared_count' },
  { label: 'Cleared Spend', name: 'cleared_spend' },
  { label: 'Cleared Rate', name: 'cleared_rate' },
  { label: 'Cleared Hist', name: 'cleared_hist' }
];

export const DAYS_BY_INDEX = ['M', 'Tu', 'W', 'Th', 'F', 'Sa', 'Su'];

export interface DayValue {
  count: number;
  spend: number;
}

export interface EstimateInfo {
  clearedSpend: number;
  orderedSpend: number;
  estimatedClearedSpend: number;
  futureOrderedSpend: number;
  historicalClearanceRate?: number;
  historicalNetworkAvailClearanceRate?: number;
  prelogLastDate: number;
  goal: number;
  goal_above: number;
  goal_below: number;
  clearanceRate?: number;
}

export interface PlanRow {
  week: string;
  network: string;
  avail: string;
  booked: DayValue[];
  cleared: DayValue[];
  estimateInfo: EstimateInfo;
  id?: string | number;
  type?: number;
  cost?: number;
  bvs?: boolean;
  prelog?: boolean;
  postlog?: boolean;
  clear_postlog?: boolean;
  // Derived/aggregated fields (clearance, totals, day-sum keys, etc.) are added dynamically.
  [key: string]: unknown;
}

export interface SpotRow {
  id: string | number;
  week: string;
  network: string;
  avail: string;
  cost: number;
  credit_amount: number;
  selected?: boolean;
  dirty?: boolean;
  accepted?: boolean;
  reconciled?: number | string;
  notes?: string;
  creditMemoStatus?: string | null;
  satellite_network?: string;
  isci?: string;
  length?: number;
  type?: number;
  program?: string;
  rotation?: string;
  mediaClassification?: string;
  campaign?: string;
  datetime_broadcast_text?: string;
  datetime_calendar_text?: string;
  adjusted_timestamp?: boolean;
  bvs?: boolean;
  prelog?: boolean;
  clear_postlog?: boolean;
  log_file?: string;
  order_file?: string;
  traffic_file?: string;
  lastmodified_text?: string;
  lastdropped_text?: string;
  [key: string]: unknown;
}

export interface DnrRow {
  week: string;
  network: string;
  avail: string;
  company?: string;
  [key: string]: unknown;
}

export interface PlansData {
  plans: PlanRow[];
  spots: SpotRow[];
  dnr: DnrRow[];
}
